module.exports = __webpack_public_path__ + "img/invoices.17442514.svg";